<template>
    <div>
        <el-form :model="vo" @submit.native.prevent>
            <div style="width:100%;" class="el-table el-table--fit el-table--border">
                <div class="el-table__body-wrapper">
                    <table cellspacing="0" cellpadding="0" border="0" class="el-table__body ">
                        <tbody>
                            <tr>
                                <td ref="tdlbl_学号" class="el-table__cell tdlbl tdw13" colspan="1">
                                    <span class="required">*</span>
                                    <span v-field-lbl="'studentId'" class="field">学号</span>
                                </td>
                                <td class="el-table__cell tdcont tdw20" colspan="1">
                                    <form-item
ref="studentId"
                                        :field="{'defaultValue':null,'elementCanEdit':'{${canEdit}}','elementCssHeight':null,'elementCssWidth':null,'elementFormatter':null,'elementReadonly':0,'elementType':'input','emptyMessage':'请输入学号','errorMessage':null,'formTdAlign':'text-left','formTdColspan':8,'isRequired':1,'onClickEvent':null,'passenger':{},'propComment':'学号','propName':'studentId','propType':'String','textFormatter':'textfield','valueMaxLength':200,'valueMinLength':null,'model':'vo.studentId','option':[]}"
                                        :vo="vo" :can-edit="canEdit"
/>
                                </td>
                                <td ref="tdlbl_姓名" class="el-table__cell tdlbl tdw13" colspan="1">
                                    <span class="required">*</span>
                                    <span v-field-lbl="'name'" class="field">姓名</span>
                                </td>
                                <td class="el-table__cell tdcont tdw20" colspan="1">
                                    <form-item
ref="name"
                                        :field="{'defaultValue':null,'elementCanEdit':'{${canEdit}}','elementCssHeight':null,'elementCssWidth':null,'elementFormatter':null,'elementReadonly':0,'elementType':'input','emptyMessage':'请输入姓名','errorMessage':null,'formTdAlign':'text-left','formTdColspan':8,'isRequired':1,'onClickEvent':null,'passenger':{},'propComment':'姓名','propName':'name','propType':'String','textFormatter':'textfield','valueMaxLength':5,'valueMinLength':null,'model':'vo.name','option':[]}"
                                        :vo="vo" :can-edit="canEdit"
/>
                                </td>
                                <td ref="tdlbl_学籍编号" class="el-table__cell tdlbl tdw13" colspan="1">
                                    <span class="required">*</span>
                                    <span v-field-lbl="'studentFileId'" class="field">学籍编号</span>
                                </td>
                                <td class="el-table__cell tdcont tdw20" colspan="1">
                                    <form-item
ref="studentFileId"
                                        :field="{'defaultValue':null,'elementCanEdit':'{${canEdit}}','elementCssHeight':null,'elementCssWidth':null,'elementFormatter':null,'elementReadonly':0,'elementType':'input','emptyMessage':'请输入学籍编号','errorMessage':null,'formTdAlign':'text-left','formTdColspan':8,'isRequired':1,'onClickEvent':null,'passenger':{},'propComment':'学籍编号','propName':'studentFileId','propType':'String','textFormatter':'textfield','valueMaxLength':50,'valueMinLength':null,'model':'vo.studentFileId','option':[],'autocomplete':'off','dialog':0,'showWordLimit':false}"
                                        :vo="vo" :can-edit="canEdit"
/>
                                </td>
                            </tr>
                            <tr>
                                <td ref="tdlbl_手机号码" class="el-table__cell tdlbl tdw13" colspan="1">
                                    <span class="required">*</span>
                                    <span v-field-lbl="'mobilePhone'" class="field">手机号码</span>
                                </td>
                                <td class="el-table__cell tdcont tdw20" colspan="1">
                                    <form-item
ref="mobilePhone"
                                        :field="{'defaultValue':null,'elementCanEdit':'{${canEdit}}','elementCssHeight':null,'elementCssWidth':null,'elementFormatter':null,'elementReadonly':0,'elementType':'input','emptyMessage':'','errorMessage':null,'isRequired':1,'onClickEvent':null,'passenger':{},'propComment':'手机号码','propName':'mobilePhone','propType':'String','textFormatter':'phone','valueMaxLength':100,'valueMinLength':null,'tbFieldName':'mobilephone','iconName':'sjhm','model':'vo.mobilePhone','option':[],'formTdAlign':'text-left','autocomplete':'off','dialog':0,'showWordLimit':false}"
                                        :vo="vo" :can-edit="canEdit"
/>
                                </td>
                                <td ref="tdlbl_有无照片" class="el-table__cell tdlbl tdw13" colspan="1">

                                    <span v-field-lbl="'hasPhoto'" class="field">有无照片</span>
                                </td>
                                <td class="el-table__cell tdcont tdw20" colspan="1">
                                    <form-item
ref="hasPhoto"
                                        :field="{'defaultValue':'0','elementCanEdit':'{${canEdit}}','elementCssHeight':null,'elementCssWidth':null,'elementFormatter':'1：有\n0：无','elementReadonly':1,'elementType':'radio','emptyMessage':'','errorMessage':null,'isRequired':0,'onClickEvent':null,'passenger':{},'propComment':'有无照片','propName':'hasPhoto','propType':'String','textFormatter':null,'valueMaxLength':null,'valueMinLength':null,'tbFieldName':'hasphoto','iconName':'dxk','model':'vo.hasPhoto','option':[{'name':'有','value':'1'},{'value':'0','name':'无'}],'formTdAlign':'text-left','optionGenerateType':0,'clearable':false,'filterable':false,'allowCreate':false}"
                                        :vo="vo" :can-edit="canEdit"
/>
                                </td>
                                <td ref="tdlbl_照片" class="el-table__cell tdlbl tdw13" colspan="1">

                                    <span v-field-lbl="'idPhoto'" class="field">照片</span>
                                </td>
                                <td class="el-table__cell tdcont tdw20" colspan="1">
                                    <el-upload
v-if="canEdit===1" ref="upload" class="upload"
                                        :on-change="handleUploadChange" action="" :show-file-list="false"
                                        :auto-upload="false" :with-credentials="true" :accept="'.jpg,.png'"
>
                                        <el-input v-model="vo.idPhoto" readonly name="idPhoto" placeholder="请上传证件照片">
                                            <el-button slot="append" icon="el-icon-upload2" />
                                        </el-input>
                                    </el-upload>
                                    <div
v-if="viewFile"
                                        style="display: flex;justify-content: center;align-items: center;"
>
                                        <img style="max-width:98%;max-height:120px;" :src="imageSrc">
                                    </div>
                                    <!-- 	<form-item ref="idPhoto" :field="{'defaultValue':'photoUrl','elementCanEdit':'{${canEdit}}','elementCssHeight':null,'elementCssWidth':null,'elementFormatter':null,'elementReadonly':0,'elementType':'file','emptyMessage':'请选择待上传图片','errorMessage':null,'isRequired':0,'onClickEvent':'','passenger':{},'propComment':'照片','propName':'idPhoto','propType':'byte[]','textFormatter':'.png, .jpg','valueMaxLength':255,'valueMinLength':null,'tbFieldName':'idphoto','iconName':'bzdtp','model':'vo.idPhoto','option':[],'downloadUrl':'xsgl/studentBasicInfo/download','formTdAlign':'text-left','formTdColspan':8,'nameField':'photoUrl','limitCount':null}" :vo="vo" :can-edit="canEdit"  /> -->
                                </td>
                            </tr>
                            <tr>
                                <td ref="tdlbl_性别" class="el-table__cell tdlbl tdw13" colspan="1">
                                    <span class="required">*</span>
                                    <span v-field-lbl="'gender'" class="field">性别</span>
                                </td>
                                <td class="el-table__cell tdcont tdw20" colspan="1">
                                    <form-item
ref="gender"
                                        :field="{'defaultValue':null,'elementCanEdit':'{${canEdit}}','elementCssHeight':null,'elementCssWidth':null,'elementFormatter':'0：男\n1：女','elementReadonly':1,'elementType':'select','emptyMessage':'请选择性别','errorMessage':null,'formTdAlign':'text-left','formTdColspan':8,'isRequired':1,'onClickEvent':null,'passenger':{},'propComment':'性别','propName':'gender','propType':'String','textFormatter':null,'valueMaxLength':4,'valueMinLength':null,'model':'vo.gender','option':[{'value':'0','name':'男'},{'value':'1','name':'女'}],'optionGenerateType':0,'clearable':false,'filterable':false,'allowCreate':false}"
                                        :vo="vo" :can-edit="canEdit"
/>
                                </td>
                                <td ref="tdlbl_出生年月" class="el-table__cell tdlbl tdw13" colspan="1">
                                    <span class="required">*</span>
                                    <span v-field-lbl="'birthDate'" class="field">出生年月</span>
                                </td>
                                <td class="el-table__cell tdcont tdw20" colspan="1">
                                    <form-item
ref="birthDate"
                                        :field="{'defaultValue':null,'elementCanEdit':'{${canEdit}}','elementCssHeight':null,'elementCssWidth':null,'elementFormatter':'','elementReadonly':1,'elementType':'date','emptyMessage':'','errorMessage':null,'isRequired':1,'onClickEvent':null,'passenger':{},'propComment':'出生年月','propName':'birthDate','propType':'java.util.Date','textFormatter':'yyyy-MM-dd','valueMaxLength':null,'valueMinLength':null,'tbFieldName':'birthdate','iconName':'sjxzk','model':'vo.birthDate','option':[],'formTdAlign':'text-left','weekday':0}"
                                        :vo="vo" :can-edit="canEdit"
/>
                                </td>
                                <td ref="tdlbl_年龄" class="el-table__cell tdlbl tdw13" colspan="1">
                                    <span class="required">*</span>
                                    <span v-field-lbl="'age'" class="field">年龄</span>
                                </td>
                                <td class="el-table__cell tdcont tdw20" colspan="1">
                                    <form-item
ref="age"
                                        :field="{'defaultValue':null,'elementCanEdit':'{${canEdit}}','elementCssHeight':null,'elementCssWidth':null,'elementFormatter':null,'elementType':'input','emptyMessage':'','errorMessage':null,'isRequired':1,'onClickEvent':null,'passenger':{},'propComment':'年龄','propName':'age','propType':'String','textFormatter':'integer','valueMaxLength':2,'valueMinLength':null,'tbFieldName':'age','iconName':'zhengshu','model':'vo.age','option':[],'formTdAlign':'text-left','autocomplete':'off','dialog':0,'showWordLimit':false}"
                                        :vo="vo" :can-edit="canEdit"
/>
                                </td>
                            </tr>
                            <tr>
                                <td ref="tdlbl_证件类型" class="el-table__cell tdlbl tdw13" colspan="1">
                                    <span class="required">*</span>
                                    <span v-field-lbl="'idType'" class="field">证件类型</span>
                                </td>
                                <td class="el-table__cell tdcont tdw20" colspan="1">
                                    <form-item
ref="idType"
                                        :field="{'defaultValue':null,'elementCanEdit':'{${canEdit}}','elementCssHeight':null,'elementCssWidth':null,'elementFormatter':'0：身份证\n1：护照\n2：其他','elementReadonly':1,'elementType':'select','emptyMessage':'请选择证件类型','errorMessage':null,'formTdAlign':'text-left','formTdColspan':8,'isRequired':1,'onClickEvent':null,'passenger':{},'propComment':'证件类型','propName':'idType','propType':'String','textFormatter':null,'valueMaxLength':20,'valueMinLength':null,'model':'vo.idType','option':[{'value':'0','name':'身份证'},{'value':'1','name':'护照'},{'value':'2','name':'其他'}],'optionGenerateType':0,'clearable':false,'filterable':false,'allowCreate':false}"
                                        :vo="vo" :can-edit="canEdit"
/>
                                </td>
                                <td ref="tdlbl_身份证" class="el-table__cell tdlbl tdw13" colspan="1">
                                    <span class="required">*</span>
                                    <span v-field-lbl="'idCardNumber'" class="field">身份证</span>
                                </td>
                                <td class="el-table__cell tdcont tdw20" colspan="1">
                                    <form-item
ref="idCardNumber"
                                        :field="{'defaultValue':null,'elementCanEdit':'{${canEdit}}','elementCssHeight':null,'elementCssWidth':null,'elementFormatter':null,'elementReadonly':0,'elementType':'input','emptyMessage':'','errorMessage':null,'isRequired':1,'onClickEvent':null,'passenger':{},'propComment':'身份证','propName':'idCardNumber','propType':'String','textFormatter':'card','valueMaxLength':100,'valueMinLength':null,'tbFieldName':'idcardnumber','iconName':'shenfenzheng','model':'vo.idCardNumber','option':[],'formTdAlign':'text-left','autocomplete':'off','dialog':0,'showWordLimit':false}"
                                        :vo="vo" :can-edit="canEdit"
/>
                                </td>
                                <td ref="tdlbl_政治面貌" class="el-table__cell tdlbl tdw13" colspan="1">
                                    <span class="required">*</span>
                                    <span v-field-lbl="'politicalStatus'" class="field">政治面貌</span>
                                </td>
                                <td class="el-table__cell tdcont tdw20" colspan="1">
                                    <form-item
ref="politicalStatus"
                                        :field="{'defaultValue':null,'elementCanEdit':'{${canEdit}}','elementCssHeight':null,'elementCssWidth':null,'elementFormatter':'0：中共党员\n1：中共预备党员\n2：共青团员\n12：群众','elementReadonly':1,'elementType':'select','emptyMessage':'请选择政治面貌','errorMessage':null,'formTdAlign':'text-left','formTdColspan':8,'isRequired':1,'onClickEvent':null,'passenger':{},'propComment':'政治面貌','propName':'politicalStatus','propType':'String','textFormatter':null,'valueMaxLength':4,'valueMinLength':null,'model':'vo.politicalStatus','option':[{'value':'0','name':'中共党员'},{'value':'1','name':'中共预备党员'},{'value':'2','name':'共青团员'},{'value':'12','name':'群众'}],'optionGenerateType':0,'clearable':false,'filterable':false,'allowCreate':false}"
                                        :vo="vo" :can-edit="canEdit"
/>
                                </td>
                            </tr>
                            <tr>
                                <td ref="tdlbl_招生年份" class="el-table__cell tdlbl tdw13" colspan="1">
                                    <span class="required">*</span>
                                    <span v-field-lbl="''" class="field">招生年份</span>
                                </td>
                                <td class="el-table__cell tdcont tdw20" colspan="1">
                                    <div v-if="canEdit==1">
                                        <el-date-picker
v-model="vo.admissionYear" type="year" placeholder="请选择"
                                            size="small" style="width:100%" value-format="yyyy"
/>
                                    </div>
                                    <div v-if="canEdit==0">
                                        {{ vo.admissionYear }}
                                    </div>
                                </td>
                                <td ref="tdlbl_招生季度" class="el-table__cell tdlbl tdw13" colspan="1">
                                    <span class="required">*</span>
                                    <span v-field-lbl="'admissionSeason'" class="field">招生季度</span>
                                </td>
                                <td class="el-table__cell tdcont tdw20" colspan="1">
                                    <form-item
ref="admissionSeason"
                                        :field="{'defaultValue':null,'elementCanEdit':'{${canEdit}}','elementCssHeight':null,'elementCssWidth':null,'elementFormatter':'0：春\n1：秋','elementReadonly':1,'elementType':'select','emptyMessage':'请选择招生季度','errorMessage':null,'formTdAlign':'text-left','formTdColspan':0,'isRequired':1,'onClickEvent':null,'passenger':{},'propComment':'招生季度','propName':'admissionSeason','propType':'String','textFormatter':null,'valueMaxLength':null,'valueMinLength':null,'model':'vo.admissionSeason','option':[{'value':'0','name':'春'},{'value':'1','name':'秋'}],'optionGenerateType':0,'clearable':false,'filterable':false,'allowCreate':false}"
                                        :vo="vo" :can-edit="canEdit"
/>
                                </td>
                                <td ref="tdlbl_学制" class="el-table__cell tdlbl tdw13" colspan="1">
                                    <span class="required">*</span>
                                    <span v-field-lbl="'educationSystem'" class="field">学制</span>
                                </td>
                                <td class="el-table__cell tdcont tdw20" colspan="1">
                                    <form-item
ref="educationSystem"
                                        :field="{'defaultValue':null,'elementCanEdit':'{${canEdit}}','elementCssHeight':null,'elementCssWidth':null,'elementFormatter':'1：二年\n2：三年\n3：四年\n4：五年\n5：六年','elementReadonly':1,'elementType':'select','emptyMessage':'','errorMessage':null,'isRequired':1,'onClickEvent':null,'passenger':{},'propComment':'学制','propName':'educationSystem','propType':'String','textFormatter':null,'valueMaxLength':50,'valueMinLength':null,'tbFieldName':'educationsystem','iconName':'xialakuang','model':'vo.educationSystem','option':[{'value':'1','name':'二年'},{'name':'三年','value':'2'},{'name':'四年','value':'3'},{'name':'五年','value':'4'},{'name':'六年','value':'5'}],'formTdAlign':'text-left','formTdColspan':8,'optionGenerateType':0,'clearable':false,'filterable':false,'allowCreate':false}"
                                        :vo="vo" :can-edit="canEdit"
/>
                                </td>
                            </tr>
                            <tr>
                                <td ref="tdlbl_院系" class="el-table__cell tdlbl tdw13" colspan="1">
                                    <span class="required">*</span>
                                    <span v-field-lbl="''" class="field">院系</span>
                                </td>
                                <td class="el-table__cell tdcont tdw20" colspan="1">
                                    <div @click="selectType('main')">
                                        <el-input
v-model="vo.majorCategory" v-listpage-dialog v-can-edit
                                            listviewurl="school.majors.listMain" dialog-title="选择专业"
                                            exclude-fields="createTime" retain-btns="" name="majorCategory"
                                            placeholder="请选择专业"
/>
                                    </div>
                                </td>
                                <td ref="tdlbl_专业" class="el-table__cell tdlbl tdw13" colspan="1">
                                    <span class="required">*</span>
                                    <span v-field-lbl="''" class="field">专业</span>
                                </td>
                                <td class="el-table__cell tdcont tdw20" colspan="1">
                                    <div v-if="vo.majorCategory" @click="selectType('sub')">
                                        <el-input
v-model="vo.majorSubcategory" v-listpage-dialog v-can-edit
                                            listviewurl="school.majors.listSub" dialog-title="选择专业"
                                            exclude-fields="createTime" retain-btns="" name="majorSubcategory"
                                            placeholder="请选择专业"
/>
                                    </div>
                                    <div v-else>
                                        <el-input
v-model="vo.majorSubcategory" readonly name="majorSubcategory"
                                            placeholder="请先选择院系"
/>
                                    </div>
                                </td>
                                <td ref="tdlbl_班级" class="el-table__cell tdlbl tdw13" colspan="1">
                                    <span class="required">*</span>
                                    <span v-field-lbl="''" class="field">班级</span>
                                </td>
                                <td class="el-table__cell tdcont tdw20" colspan="1">
                                    <div v-if="vo.majorSubcategory" @click="selectType('className')">
                                        <el-input
v-model="vo.className" v-listpage-dialog v-can-edit
                                            listviewurl="school.clazz.list" dialog-title="选择班级"
                                            exclude-fields="createTime" retain-btns="" name="className"
                                            placeholder="请选择班级"
/>
                                    </div>
                                    <div v-else>
                                        <el-input
v-model="vo.className" readonly name="majorSubcategory"
                                            placeholder="请先选择专业"
/>
                                    </div>
                                </td>
                            </tr>
                            <tr>
                                <td ref="tdlbl_学习形式" class="el-table__cell tdlbl tdw13" colspan="1">
                                    <span class="required">*</span>
                                    <span v-field-lbl="'studyForm'" class="field">学习形式</span>
                                </td>
                                <td class="el-table__cell tdcont tdw20" colspan="1">
                                    <form-item
ref="studyForm"
                                        :field="{'defaultValue':'0','elementCanEdit':'{${canEdit}}','elementCssHeight':null,'elementCssWidth':null,'elementFormatter':'0：全日制\n1：非全日制','elementReadonly':1,'elementType':'radio','emptyMessage':'请选择学习形式','errorMessage':null,'formTdAlign':'text-left','formTdColspan':0,'isRequired':1,'onClickEvent':null,'passenger':{},'propComment':'学习形式','propName':'studyForm','propType':'String','textFormatter':null,'valueMaxLength':null,'valueMinLength':null,'model':'vo.studyForm','option':[{'value':'0','name':'全日制'},{'value':'1','name':'非全日制'}],'optionGenerateType':0,'clearable':false,'filterable':false,'allowCreate':false}"
                                        :vo="vo" :can-edit="canEdit"
/>
                                </td>
                                <td ref="tdlbl_入学时间" class="el-table__cell tdlbl tdw13" colspan="1">
                                    <span class="required">*</span>
                                    <span v-field-lbl="'enrollmentDate'" class="field">入学时间</span>
                                </td>
                                <td class="el-table__cell tdcont tdw20" colspan="1">
                                    <form-item
ref="enrollmentDate"
                                        :field="{'defaultValue':null,'elementCanEdit':'{${canEdit}}','elementCssHeight':null,'elementCssWidth':null,'elementFormatter':'','elementReadonly':1,'elementType':'date','emptyMessage':'','errorMessage':null,'isRequired':1,'onClickEvent':null,'passenger':{},'propComment':'入学时间','propName':'enrollmentDate','propType':'java.util.Date','textFormatter':'yyyy-MM-dd','valueMaxLength':null,'valueMinLength':null,'tbFieldName':'enrollmentdate','iconName':'sjxzk','model':'vo.enrollmentDate','option':[],'formTdAlign':'text-left','weekday':0}"
                                        :vo="vo" :can-edit="canEdit"
/>
                                </td>
                                <td ref="tdlbl_专业版本" class="el-table__cell tdlbl tdw13" colspan="1">
                                    <span class="required">*</span>
                                    <span v-field-lbl="''" class="field">专业版本</span>
                                </td>
                                <td class="el-table__cell tdcont tdw20" colspan="1">
                                    <div v-if="canEdit==1">
                                        <el-date-picker
v-model="vo.majorVersion" type="year" placeholder="请选择"
                                            size="small" style="width:100%" value-format="yyyy"
/>
                                    </div>
                                    <div v-if="canEdit==0">
                                        {{ vo.majorVersion }}
                                    </div>
                                </td>
                            </tr>
                            <tr>
                                <td ref="tdlbl_民族" class="el-table__cell tdlbl tdw13" colspan="1">
                                    <span class="required">*</span>
                                    <span v-field-lbl="'ethnicity'" class="field">民族</span>
                                </td>
                                <td class="el-table__cell tdcont tdw20" colspan="1">
                                    <form-item
ref="ethnicity" :field="{defaultValue: null,
                                            elementCanEdit: '{${canEdit}}',
                                            elementCssHeight: null,
                                            elementCssWidth: null,
                                            elementFormatter:
                                                '汉族：汉族\n满族：满族\n蒙古族：蒙古族\n回族：回族\n藏族：藏族\n维吾尔族：维吾尔族\n苗族：苗族\n彝族：彝族\n壮族：壮族\n布依族：布依族\n侗族：侗族\n瑶族：瑶族\n白族：白族\n土家族：土家族\n哈尼族：哈尼族\n哈萨克族：哈萨克族\n傣族：傣族\n黎族：黎族\n傈僳族：傈僳族\n佤族：佤族\n畲族：畲族\n高山族：高山族\n拉祜族：拉祜族\n水族：水族\n东乡族：东乡族\n纳西族：纳西族\n景颇族：景颇族\n赫哲族：赫哲族\n柯尔克孜族：柯尔克孜族\n土族：土族\n达斡尔族：达斡尔族\n仫佬族：仫佬族\n羌族：羌族\n布朗族：布朗族\n撒拉族：撒拉族\n毛南族：毛南族\n仡佬族：仡佬族\n锡伯族：锡伯族\n阿昌族：阿昌族\n普米族：普米族\n朝鲜族：朝鲜族\n塔吉克族：塔吉克族\n怒族：怒族\n乌孜别克族：乌孜别克族\n俄罗斯族：俄罗斯族\n鄂温克族：鄂温克族\n德昂族：德昂族\n保安族：保安族\n裕固族：裕固族\n京族：京族\n塔塔尔族：塔塔尔族\n独龙族：独龙族\n鄂伦春族：鄂伦春族\n门巴族：门巴族\n珞巴族：珞巴族\n基诺族：基诺族',
                                            elementReadonly: 0,
                                            elementType: 'select',
                                            emptyMessage: '请输入民族',
                                            errorMessage: null,
                                            formTdAlign: 'text-left',
                                            formTdColspan: 8,
                                            isRequired: 1,
                                            onClickEvent: null,
                                            passenger: {},
                                            propComment: '民族',
                                            propName: 'ethnicity',
                                            propType: 'String',
                                            textFormatter: 'textfield',
                                            valueMaxLength: 30,
                                            valueMinLength: null,
                                            model: 'vo.ethnicity',
                                            option: [
                                                { value: '汉族', name: '汉族' },
                                                { value: '满族', name: '满族' },
                                                { value: '蒙古族', name: '蒙古族' },
                                                { value: '回族', name: '回族' },
                                                { value: '藏族', name: '藏族' },
                                                { value: '维吾尔族', name: '维吾尔族' },
                                                { value: '苗族', name: '苗族' },
                                                { value: '彝族', name: '彝族' },
                                                { value: '壮族', name: '壮族' },
                                                { value: '布依族', name: '布依族' },
                                                { value: '侗族', name: '侗族' },
                                                { value: '瑶族', name: '瑶族' },
                                                { value: '白族', name: '白族' },
                                                { value: '土家族', name: '土家族' },
                                                { value: '哈尼族', name: '哈尼族' },
                                                { value: '哈萨克族', name: '哈萨克族' },
                                                { value: '傣族', name: '傣族' },
                                                { value: '黎族', name: '黎族' },
                                                { value: '傈僳族', name: '傈僳族' },
                                                { value: '佤族', name: '佤族' },
                                                { value: '畲族', name: '畲族' },
                                                { value: '高山族', name: '高山族' },
                                                { value: '拉祜族', name: '拉祜族' },
                                                { value: '水族', name: '水族' },
                                                { value: '东乡族', name: '东乡族' },
                                                { value: '纳西族', name: '纳西族' },
                                                { value: '景颇族', name: '景颇族' },
                                                { value: '柯尔克孜族', name: '柯尔克孜族' },
                                                { value: '土族', name: '土族' },
                                                { value: '达斡尔族', name: '达斡尔族' },
                                                { value: '仫佬族', name: '仫佬族' },
                                                { value: '羌族', name: '羌族' },
                                                { value: '布朗族', name: '布朗族' },
                                                { value: '撒拉族', name: '撒拉族' },
                                                { value: '毛南族', name: '毛南族' },
                                                { value: '仡佬族', name: '仡佬族' },
                                                { value: '锡伯族', name: '锡伯族' },
                                                { value: '阿昌族', name: '阿昌族' },
                                                { value: '普米族', name: '普米族' },
                                                { value: '朝鲜族', name: '朝鲜族' },
                                                { value: '赫哲族', name: '赫哲族' },
                                                { value: '塔吉克族', name: '塔吉克族' },
                                                { value: '怒族', name: '怒族' },
                                                { value: '乌孜别克族', name: '乌孜别克族' },
                                                { value: '俄罗斯族', name: '俄罗斯族' },
                                                { value: '鄂温克族', name: '鄂温克族' },
                                                { value: '德昂族', name: '德昂族' },
                                                { value: '保安族', name: '保安族' },
                                                { value: '裕固族', name: '裕固族' },
                                                { value: '京族', name: '京族' },
                                                { value: '塔塔尔族', name: '塔塔尔族' },
                                                { value: '独龙族', name: '独龙族' },
                                                { value: '鄂伦春族', name: '鄂伦春族' },
                                                { value: '门巴族', name: '门巴族' },
                                                { value: '珞巴族', name: '珞巴族' },
                                                { value: '基诺族', name: '基诺族' }
                                            ],
                                            optionGenerateType: 0,
                                            clearable: true,
                                            filterable: false,
                                            allowCreate: false}" :vo="vo" :can-edit="canEdit"
/>
                                </td>
                                <td ref="tdlbl_培养层次" class="el-table__cell tdlbl tdw13" colspan="1">
                                    <span class="required">*</span>
                                    <span v-field-lbl="'educationLevel'" class="field">培养层次</span>
                                </td>
                                <td class="el-table__cell tdcont tdw20" colspan="1">
                                    <form-item
ref="educationLevel"
                                        :field="{'defaultValue':null,'elementCanEdit':'{${canEdit}}','elementCssHeight':null,'elementCssWidth':null,'elementFormatter':'0：初技\n1：中技\n2：高技\n3：预备技师\n4：技师','elementReadonly':1,'elementType':'select','emptyMessage':'','errorMessage':null,'isRequired':1,'onClickEvent':null,'passenger':{},'propComment':'培养层次','propName':'educationLevel','propType':'String','textFormatter':null,'valueMaxLength':50,'valueMinLength':null,'tbFieldName':'educationlevel','iconName':'xialakuang','model':'vo.educationLevel','option':[{'value':'0','name':'初技'},{'name':'中技','value':'1'},{'name':'高技','value':'2'},{'name':'预备技师','value':'3'},{'name':'技师','value':'4'}],'formTdAlign':'text-left','optionGenerateType':0,'clearable':false,'filterable':false,'allowCreate':false}"
                                        :vo="vo" :can-edit="canEdit"
/>
                                </td>
                                <td ref="tdlbl_是否新型学徒" class="el-table__cell tdlbl tdw13" colspan="1">

                                    <span v-field-lbl="'isApprentice'" class="field">是否新型学徒</span>
                                </td>
                                <td class="el-table__cell tdcont tdw20" colspan="1">
                                    <form-item
ref="isApprentice"
                                        :field="{'defaultValue':null,'elementCanEdit':'{${canEdit}}','elementCssHeight':null,'elementCssWidth':null,'elementFormatter':'0：是\n1：否','elementReadonly':0,'elementType':'radio','emptyMessage':'请选择是否新型学徒','errorMessage':null,'formTdAlign':'text-left','formTdColspan':8,'isRequired':0,'onClickEvent':null,'passenger':{},'propComment':'是否新型学徒','propName':'isApprentice','propType':'String','textFormatter':null,'valueMaxLength':4,'valueMinLength':null,'model':'vo.isApprentice','option':[{'value':'0','name':'是'},{'value':'1','name':'否'}],'optionGenerateType':0,'clearable':false,'filterable':false,'allowCreate':false}"
                                        :vo="vo" :can-edit="canEdit"
/>
                                </td>
                            </tr>
                            <tr>
                                <td ref="tdlbl_学前技能水平" class="el-table__cell tdlbl tdw13" colspan="1">

                                    <span v-field-lbl="'previousSkillLevel'" class="field">学前技能水平</span>
                                </td>
                                <td class="el-table__cell tdcont tdw20" colspan="1">
                                    <form-item
ref="previousSkillLevel"
                                        :field="{'defaultValue':null,'elementCanEdit':'{${canEdit}}','elementCssHeight':null,'elementCssWidth':null,'elementFormatter':'初级：初级\n中级：中级\n高级：高级\n预备技师：预备技师\n技师：技师','elementReadonly':1,'elementType':'select','emptyMessage':'','errorMessage':null,'isRequired':0,'onClickEvent':null,'passenger':{},'propComment':'学前技能水平','propName':'previousSkillLevel','propType':'String','textFormatter':null,'valueMaxLength':50,'valueMinLength':null,'tbFieldName':'previousskilllevel','iconName':'xialakuang','model':'vo.previousSkillLevel','option':[{'value':'初级','name':'初级'},{'name':'中级','value':'中级'},{'name':'高级','value':'高级'},{'name':'预备技师','value':'预备技师'},{'name':'技师','value':'技师'}],'formTdAlign':'text-left','optionGenerateType':0,'clearable':false,'filterable':false,'allowCreate':false}"
                                        :vo="vo" :can-edit="canEdit"
/>
                                </td>
                                <td ref="tdlbl_以前学历" class="el-table__cell tdlbl tdw13" colspan="1">
                                    <span class="required">*</span>
                                    <span v-field-lbl="'previousEducation'" class="field">以前学历</span>
                                </td>
                                <td class="el-table__cell tdcont tdw20" colspan="1">
                                    <form-item
ref="previousEducation"
                                        :field="{'defaultValue':null,'elementCanEdit':'{${canEdit}}','elementCssHeight':null,'elementCssWidth':null,'elementFormatter':'0：本科\n1：大专\n2：中专\n3：高中\n4：技校\n5：职高\n6：初中','elementReadonly':1,'elementType':'select','emptyMessage':'','errorMessage':null,'isRequired':1,'onClickEvent':null,'passenger':{},'propComment':'以前学历','propName':'previousEducation','propType':'String','textFormatter':null,'valueMaxLength':50,'valueMinLength':null,'tbFieldName':'previouseducation','iconName':'xialakuang','model':'vo.previousEducation','option':[{'value':'0','name':'本科'},{'name':'大专','value':'1'},{'name':'中专','value':'2'},{'name':'高中','value':'3'},{'name':'技校','value':'4'},{'name':'职高','value':'5'},{'name':'初中','value':'6'}],'formTdAlign':'text-left','optionGenerateType':0,'clearable':false,'filterable':false,'allowCreate':false}"
                                        :vo="vo" :can-edit="canEdit"
/>
                                </td>
                                <td ref="tdlbl_毕业学校" class="el-table__cell tdlbl tdw13" colspan="1">
                                    <span class="required">*</span>
                                    <span v-field-lbl="'graduationSchool'" class="field">毕业学校</span>
                                </td>
                                <td class="el-table__cell tdcont tdw20" colspan="1">
                                    <form-item
ref="graduationSchool"
                                        :field="{'defaultValue':null,'elementCanEdit':'{${canEdit}}','elementCssHeight':null,'elementCssWidth':null,'elementFormatter':null,'elementType':'input','emptyMessage':'请输入毕业学校','errorMessage':null,'formTdAlign':'text-left','formTdColspan':0,'isRequired':1,'onClickEvent':null,'passenger':{},'propComment':'毕业学校','propName':'graduationSchool','propType':'String','textFormatter':'textfield','valueMaxLength':null,'valueMinLength':null,'model':'vo.graduationSchool','option':[],'autocomplete':'off','dialog':0,'showWordLimit':false}"
                                        :vo="vo" :can-edit="canEdit"
/>
                                </td>
                            </tr>
                            <tr>
                                <td ref="tdlbl_户口所在地" class="el-table__cell tdlbl tdw13" colspan="1">
                                    <span class="required">*</span>
                                    <span v-field-lbl="'householdRegistration'" class="field">户口所在地</span>
                                </td>
                                <td class="el-table__cell tdcont tdw20" colspan="1">
                                    <form-item
ref="householdRegistration"
                                        :field="{'defaultValue':null,'elementCanEdit':'{${canEdit}}','elementCssHeight':null,'elementCssWidth':null,'elementFormatter':null,'elementType':'input','emptyMessage':'请输入户口所在地（XX省XX市XX县/区）','errorMessage':null,'formTdAlign':'text-left','formTdColspan':0,'isRequired':1,'onClickEvent':null,'passenger':{},'propComment':'户口所在地','propName':'householdRegistration','propType':'String','textFormatter':'textfield','valueMaxLength':null,'valueMinLength':null,'model':'vo.householdRegistration','option':[],'autocomplete':'off','dialog':0,'showWordLimit':false}"
                                        :vo="vo" :can-edit="canEdit"
/>
                                </td>
                                <td ref="tdlbl_是否家庭困难" class="el-table__cell tdlbl tdw13" colspan="1">
                                    <span class="required">*</span>
                                    <span v-field-lbl="'isFamilyDifficult'" class="field">是否家庭困难</span>
                                </td>
                                <td class="el-table__cell tdcont tdw20" colspan="1">
                                    <form-item
ref="isFamilyDifficult"
                                        :field="{'defaultValue':null,'elementCanEdit':'{${canEdit}}','elementCssHeight':null,'elementCssWidth':null,'elementFormatter':'1：是\n0：否','elementReadonly':1,'elementType':'radio','emptyMessage':'请选择是否家庭困难','errorMessage':null,'formTdAlign':'text-left','formTdColspan':0,'isRequired':1,'onClickEvent':null,'passenger':{},'propComment':'是否家庭困难','propName':'isFamilyDifficult','propType':'String','textFormatter':null,'valueMaxLength':null,'valueMinLength':null,'model':'vo.isFamilyDifficult','option':[{'value':'1','name':'是'},{'value':'0','name':'否'}],'optionGenerateType':0,'clearable':false,'filterable':false,'allowCreate':false}"
                                        :vo="vo" :can-edit="canEdit"
/>
                                </td>
                                <td ref="tdlbl_家庭困难类型" class="el-table__cell tdlbl tdw13" colspan="1">

                                    <span v-field-lbl="'familyDifficultyType'" class="field">家庭困难类型</span>
                                </td>
                                <td class="el-table__cell tdcont tdw20" colspan="1">
                                    <form-item
ref="familyDifficultyType"
                                        :field="{'defaultValue':null,'elementCanEdit':'{${canEdit}}','elementCssHeight':null,'elementCssWidth':null,'elementFormatter':'0：建档立卡家庭\n1：低保家庭\n2：特困供养\n3：孤残学生\n4：烈士子女\n5：家庭经济困难残疾学生及残疾人子女\n6：其他','elementReadonly':1,'elementType':'select','emptyMessage':'','errorMessage':null,'isRequired':0,'onClickEvent':null,'passenger':{},'propComment':'家庭困难类型','propName':'familyDifficultyType','propType':'String','textFormatter':null,'valueMaxLength':50,'valueMinLength':null,'tbFieldName':'familydifficultytype','iconName':'xialakuang','model':'vo.familyDifficultyType','option':[{'value':'0','name':'建档立卡家庭'},{'name':'低保家庭','value':'1'},{'name':'特困供养','value':'2'},{'name':'孤残学生','value':'3'},{'name':'烈士子女','value':'4'},{'name':'家庭经济困难残疾学生及残疾人子女','value':'5'},{'name':'其他','value':'6'}],'formTdAlign':'text-left','optionGenerateType':0,'clearable':false,'filterable':false,'allowCreate':false}"
                                        :vo="vo" :can-edit="canEdit"
/>
                                </td>
                            </tr>
                            <tr>
                                <td ref="tdlbl_户口性质" class="el-table__cell tdlbl tdw13" colspan="1">
                                    <span class="required">*</span>
                                    <span v-field-lbl="'hukouNature'" class="field">户口性质</span>
                                </td>
                                <td class="el-table__cell tdcont tdw20" colspan="1">
                                    <form-item
ref="hukouNature"
                                        :field="{'defaultValue':null,'elementCanEdit':'{${canEdit}}','elementCssHeight':null,'elementCssWidth':null,'elementFormatter':'0：农村\n1：城镇','elementReadonly':1,'elementType':'radio','emptyMessage':'请选择户口性质','errorMessage':null,'formTdAlign':'text-left','formTdColspan':0,'isRequired':1,'onClickEvent':null,'passenger':{},'propComment':'户口性质','propName':'hukouNature','propType':'String','textFormatter':null,'valueMaxLength':null,'valueMinLength':null,'model':'vo.hukouNature','option':[{'value':'0','name':'农村'},{'value':'1','name':'城镇'}],'optionGenerateType':0,'clearable':false,'filterable':false,'allowCreate':false}"
                                        :vo="vo" :can-edit="canEdit"
/>
                                </td>
                                <td ref="tdlbl_家庭联系人姓名" class="el-table__cell tdlbl tdw13" colspan="1">
                                    <span class="required">*</span>
                                    <span v-field-lbl="'familyContactName'" class="field">家庭联系人姓名</span>
                                </td>
                                <td class="el-table__cell tdcont tdw20" colspan="1">
                                    <form-item
ref="familyContactName"
                                        :field="{'defaultValue':null,'elementCanEdit':'{${canEdit}}','elementCssHeight':null,'elementCssWidth':null,'elementFormatter':null,'elementType':'input','emptyMessage':'请输入家庭联系人姓名','errorMessage':null,'formTdAlign':'text-left','formTdColspan':0,'isRequired':1,'onClickEvent':null,'passenger':{},'propComment':'家庭联系人姓名','propName':'familyContactName','propType':'String','textFormatter':'textfield','valueMaxLength':null,'valueMinLength':null,'model':'vo.familyContactName','option':[],'autocomplete':'off','dialog':0,'showWordLimit':false}"
                                        :vo="vo" :can-edit="canEdit"
/>
                                </td>
                                <td ref="tdlbl_家庭联系人电话" class="el-table__cell tdlbl tdw13" colspan="1">
                                    <span class="required">*</span>
                                    <span v-field-lbl="'familyContactPhone'" class="field">家庭联系人电话</span>
                                </td>
                                <td class="el-table__cell tdcont tdw20" colspan="1">
                                    <form-item
ref="familyContactPhone"
                                        :field="{'defaultValue':null,'elementCanEdit':'{${canEdit}}','elementCssHeight':null,'elementCssWidth':null,'elementFormatter':null,'elementType':'input','emptyMessage':'请输入家庭联系人电话','errorMessage':null,'formTdAlign':'text-left','formTdColspan':0,'isRequired':1,'onClickEvent':null,'passenger':{},'propComment':'家庭联系人电话','propName':'familyContactPhone','propType':'String','textFormatter':'textfield','valueMaxLength':null,'valueMinLength':null,'model':'vo.familyContactPhone','option':[],'autocomplete':'off','dialog':0,'showWordLimit':false}"
                                        :vo="vo" :can-edit="canEdit"
/>
                                </td>
                            </tr>
                            <tr>
                                <td ref="tdlbl_资助申请类型" class="el-table__cell tdlbl tdw13" colspan="1">
                                    <span class="required">*</span>
                                    <span v-field-lbl="'selfApplicationType'" class="field">资助申请类型</span>
                                </td>
                                <td class="el-table__cell tdcont tdw20" colspan="1">
                                    <form-item
ref="selfApplicationType"
                                        :field="{'defaultValue':null,'elementCanEdit':'{${canEdit}}','elementCssHeight':null,'elementCssWidth':null,'elementFormatter':'0：都不申请\n1：都申请\n2：申请助学金\n3：申请免学费','elementReadonly':1,'elementType':'select','emptyMessage':'','errorMessage':null,'isRequired':1,'onClickEvent':null,'passenger':{},'propComment':'资助申请类型','propName':'selfApplicationType','propType':'String','textFormatter':null,'valueMaxLength':50,'valueMinLength':null,'tbFieldName':'selfapplicationtype','iconName':'xialakuang','model':'vo.selfApplicationType','option':[{'value':'0','name':'都不申请'},{'name':'都申请','value':'1'},{'name':'申请助学金','value':'2'},{'name':'申请免学费','value':'3'}],'formTdAlign':'text-left','optionGenerateType':0,'clearable':false,'filterable':false,'allowCreate':false}"
                                        :vo="vo" :can-edit="canEdit"
/>
                                </td>
                                <td ref="tdlbl_家庭年收入（元）" class="el-table__cell tdlbl tdw13" colspan="1">
                                    <span class="required">*</span>
                                    <span v-field-lbl="'familyIncome'" class="field">家庭年收入（元）</span>
                                </td>
                                <td class="el-table__cell tdcont tdw20" colspan="1">
                                    <form-item
ref="familyIncome"
                                        :field="{'defaultValue':null,'elementCanEdit':'{${canEdit}}','elementCssHeight':null,'elementCssWidth':null,'elementFormatter':null,'elementType':'input','emptyMessage':'请输入家庭年收入（元）','errorMessage':null,'formTdAlign':'text-left','formTdColspan':0,'isRequired':1,'onClickEvent':null,'passenger':{},'propComment':'家庭年收入（元）','propName':'familyIncome','propType':'java.math.BigDecimal','textFormatter':'textfield','valueMaxLength':null,'valueMinLength':null,'model':'vo.familyIncome','option':[],'autocomplete':'off','dialog':0,'showWordLimit':false}"
                                        :vo="vo" :can-edit="canEdit"
/>
                                </td>
                                <td ref="tdlbl_家庭人均收入（元）" class="el-table__cell tdlbl tdw13" colspan="1">
                                    <span class="required">*</span>
                                    <span v-field-lbl="'perCapitaIncome'" class="field">家庭人均收入（元）</span>
                                </td>
                                <td class="el-table__cell tdcont tdw20" colspan="1">
                                    <form-item
ref="perCapitaIncome"
                                        :field="{'defaultValue':null,'elementCanEdit':'{${canEdit}}','elementCssHeight':null,'elementCssWidth':null,'elementFormatter':null,'elementType':'input','emptyMessage':'请输入家庭人均收入（元）','errorMessage':null,'formTdAlign':'text-left','formTdColspan':0,'isRequired':1,'onClickEvent':null,'passenger':{},'propComment':'家庭人均收入（元）','propName':'perCapitaIncome','propType':'java.math.BigDecimal','textFormatter':'textfield','valueMaxLength':null,'valueMinLength':null,'model':'vo.perCapitaIncome','option':[],'autocomplete':'off','dialog':0,'showWordLimit':false}"
                                        :vo="vo" :can-edit="canEdit"
/>
                                </td>
                            </tr>
                            <tr>
                                <td ref="tdlbl_家庭经济来源" class="el-table__cell tdlbl tdw13" colspan="1">
                                    <span class="required">*</span>
                                    <span v-field-lbl="'familyEconomicSource'" class="field">家庭经济来源</span>
                                </td>
                                <td class="el-table__cell tdcont tdw20" colspan="1">
                                    <form-item
ref="familyEconomicSource"
                                        :field="{'defaultValue':null,'elementCanEdit':'{${canEdit}}','elementCssHeight':70,'elementCssWidth':null,'elementFormatter':null,'elementType':'textarea','emptyMessage':'请输入家庭经济来源','errorMessage':null,'formTdAlign':'text-left','formTdColspan':0,'isRequired':1,'onClickEvent':null,'passenger':{},'propComment':'家庭经济来源','propName':'familyEconomicSource','propType':'String','textFormatter':'textarea','valueMaxLength':null,'valueMinLength':null,'model':'vo.familyEconomicSource','option':[],'autosize':false}"
                                        :vo="vo" :can-edit="canEdit" :autosize="false"
/>
                                </td>
                                <td ref="tdlbl_邮编" class="el-table__cell tdlbl tdw13" colspan="1">
                                    <span class="required">*</span>
                                    <span v-field-lbl="'postalCode'" class="field">邮编</span>
                                </td>
                                <td class="el-table__cell tdcont tdw20" colspan="1">
                                    <form-item
ref="postalCode"
                                        :field="{'defaultValue':null,'elementCanEdit':'{${canEdit}}','elementCssHeight':null,'elementCssWidth':null,'elementFormatter':null,'elementType':'input','emptyMessage':'请输入邮编','errorMessage':null,'formTdAlign':'text-left','formTdColspan':0,'isRequired':1,'onClickEvent':null,'passenger':{},'propComment':'邮编','propName':'postalCode','propType':'String','textFormatter':'textfield','valueMaxLength':null,'valueMinLength':null,'model':'vo.postalCode','option':[],'autocomplete':'off','dialog':0,'showWordLimit':false}"
                                        :vo="vo" :can-edit="canEdit"
/>
                                </td>
                                <td ref="tdlbl_家庭地址" class="el-table__cell tdlbl tdw13" colspan="1">
                                    <span class="required">*</span>
                                    <span v-field-lbl="'familyAddress'" class="field">家庭地址</span>
                                </td>
                                <td class="el-table__cell tdcont tdw20" colspan="1">
                                    <form-item
ref="familyAddress"
                                        :field="{'defaultValue':null,'elementCanEdit':'{${canEdit}}','elementCssHeight':null,'elementCssWidth':null,'elementFormatter':null,'elementType':'input','emptyMessage':'请输入家庭地址','errorMessage':null,'formTdAlign':'text-left','formTdColspan':0,'isRequired':1,'onClickEvent':null,'passenger':{},'propComment':'家庭地址','propName':'familyAddress','propType':'String','textFormatter':'textfield','valueMaxLength':null,'valueMinLength':null,'model':'vo.familyAddress','option':[],'autocomplete':'off','dialog':0,'showWordLimit':false}"
                                        :vo="vo" :can-edit="canEdit"
/>
                                </td>
                            </tr>
                            <tr>
                                <td ref="tdlbl_银行卡号" class="el-table__cell tdlbl tdw13" colspan="1">

                                    <span v-field-lbl="'bankAccount'" class="field">银行卡号</span>
                                </td>
                                <td class="el-table__cell tdcont tdw20" colspan="1">
                                    <form-item
ref="bankAccount"
                                        :field="{'defaultValue':null,'elementCanEdit':'{${canEdit}}','elementCssHeight':null,'elementCssWidth':null,'elementFormatter':null,'elementType':'input','emptyMessage':'请输入银行卡号','errorMessage':null,'formTdAlign':'text-left','formTdColspan':0,'isRequired':0,'onClickEvent':null,'passenger':{},'propComment':'银行卡号','propName':'bankAccount','propType':'String','textFormatter':'textfield','valueMaxLength':null,'valueMinLength':null,'model':'vo.bankAccount','option':[]}"
                                        :vo="vo" :can-edit="canEdit"
/>
                                </td>
                                <td ref="tdlbl_社保号" class="el-table__cell tdlbl tdw13" colspan="1">

                                    <span v-field-lbl="'socialSecurityNumber'" class="field">社保号</span>
                                </td>
                                <td class="el-table__cell tdcont tdw20" colspan="1">
                                    <form-item
ref="socialSecurityNumber"
                                        :field="{'defaultValue':null,'elementCanEdit':'{${canEdit}}','elementCssHeight':null,'elementCssWidth':null,'elementFormatter':null,'elementType':'input','emptyMessage':'请输入社保号','errorMessage':null,'formTdAlign':'text-left','formTdColspan':0,'isRequired':0,'onClickEvent':null,'passenger':{},'propComment':'社保号','propName':'socialSecurityNumber','propType':'String','textFormatter':'textfield','valueMaxLength':null,'valueMinLength':null,'model':'vo.socialSecurityNumber','option':[]}"
                                        :vo="vo" :can-edit="canEdit"
/>
                                </td>
                                <td ref="tdlbl_兴趣爱好" class="el-table__cell tdlbl tdw13" colspan="1">

                                    <span v-field-lbl="'hobbies'" class="field">兴趣爱好</span>
                                </td>
                                <td class="el-table__cell tdcont tdw20" colspan="1">
                                    <form-item
ref="hobbies"
                                        :field="{'defaultValue':null,'elementCanEdit':'{${canEdit}}','elementCssHeight':70,'elementCssWidth':null,'elementFormatter':null,'elementType':'textarea','emptyMessage':'请输入兴趣爱好','errorMessage':null,'formTdAlign':'text-left','formTdColspan':0,'isRequired':0,'onClickEvent':null,'passenger':{},'propComment':'兴趣爱好','propName':'hobbies','propType':'String','textFormatter':'textarea','valueMaxLength':null,'valueMinLength':null,'model':'vo.hobbies','option':[]}"
                                        :vo="vo" :can-edit="canEdit"
/>
                                </td>
                            </tr>
                            <tr>
                                <td class="el-table__cell tdcont tdcont-innertb" colspan="6">
                                    <div>
                                        <!-- <div style="padding-left:10px;font-weight:bold;">家庭成员</div>
                        <div style="border-top: 1px solid #999;">
                            <inner-table id="innerTable" ref="innerTable" :listviewurl="'studentFamilyMembers.list'" :exclude-fields="''"  :link-prop-name="'studentId'" :is-cell-click="false"
                              :can-edit="canEdit"
                              :can-delete="canEdit"
                              :can-add="canEdit"
                              :in-line-edit="canEdit"
                              :show-toolbar="0"
                              :pagination="0"/>
                        </div>
                    </div> -->
                                        <div class="familyMembers_title">
                                            <div class="familyMembers_title_left">
                                                <span
                                                    style="font-size: 14px;padding-left: 10px;margin-bottom: 10px;"
>家庭成员</span>
                                            </div>
                                            <div class="familyMembers_title_right">
                                                <el-button
v-if="canEdit" size="mini"
                                                    @click="addfamilyMembers"
>添加</el-button>
                                            </div>
                                        </div>
                                        <el-table :data="familyMembers" style="width: 100%" class="">
                                            <el-table-column type="index" label="序号" width="50" align="center" />
                                            <el-table-column
prop="familyMemberName" label="姓名" align="center"
                                                width="180px"
>
                                                <template slot-scope="scope">
                                                    <form-item
ref="familyMemberName"
                                                        :field="{ defaultValue: null, elementCanEdit: '{${canEdit}}', elementCssHeight: null, elementCssWidth: null, elementFormatter: null, elementReadonly: 0, elementType: 'input', emptyMessage: '请输入姓名', errorMessage: null, formTdAlign: 'text-left', formTdColspan: 0, isRequired: 0, onClickEvent: null, passenger: {}, propComment: '姓名', propName: 'familyMemberName', propType: 'String', textFormatter: 'textfield', valueMaxLength: null, valueMinLength: null, model: 'scope.row.familyMemberName', option: [], autocomplete: 'off', showWordLimit: false }"
                                                        :vo="scope.row" :can-edit="canEdit"
/>
                                                </template>
                                            </el-table-column>
                                            <el-table-column
prop="relationship" label="与本人关系" align="center"
                                                width="150px"
>
                                                <template slot-scope="scope">
                                                    <form-item
ref="relationship" :field="{ defaultValue: null,
                                                elementCanEdit: '{${canEdit}}',
                                                elementCssHeight: null,
                                                elementCssWidth: null,
                                                elementFormatter: '0：父亲\n1：母亲\n2：其他监护人',
                                                elementReadonly: 1,
                                                elementType: 'select',
                                                emptyMessage: '请选择与本人关系',
                                                errorMessage: null,
                                                isRequired: 0,
                                                onClickEvent: null,
                                                passenger: {},
                                                propComment: '与本人关系',
                                                propName: 'relationship',
                                                propType: 'String',
                                                textFormatter: null,
                                                valueMaxLength: 50,
                                                valueMinLength: null,
                                                tbFieldName: 'relationship',
                                                iconName: 'xialakuang',
                                                model: 'scope.row.relationship',
                                                option: [
                                                    { name: '父亲', value: '0' },
                                                    { name: '母亲', value: '1' },
                                                    { name: '其他监护人', value: '2' },
                                                ],
                                                formTdAlign: 'text-left',
                                                optionGenerateType: 0,
                                                clearable: true,
                                                filterable: false,
                                                allowCreate: false }" :vo="scope.row" :can-edit="canEdit"
/>
                                                </template>
                                            </el-table-column>
                                            <el-table-column prop="politicalStatus" label="政治面貌" align="center">
                                                <template slot-scope="scope">
                                                    <form-item
ref="politicalStatus" :field="{
                                                defaultValue: null,
                                                elementCanEdit: '{${canEdit}}',
                                                elementCssHeight: null,
                                                elementCssWidth: null,
                                                elementFormatter: '中共党员：中共党员\n中国预备党员：中国预备党员\n共青团员：共青团员\n群众：群众',
                                                elementReadonly: 1,
                                                elementType: 'select',
                                                emptyMessage: '请选择政治面貌',
                                                errorMessage: null,
                                                isRequired: 0,
                                                onClickEvent: null,
                                                passenger: {},
                                                propComment: '政治面貌',
                                                propName: 'politicalStatus',
                                                propType: 'String',
                                                textFormatter: null,
                                                valueMaxLength: 50,
                                                valueMinLength: null,
                                                tbFieldName: 'memberpoliticaloutlook',
                                                iconName: 'xialakuang',
                                                model: 'scope.row.politicalStatus',
                                                option: [
                                                    { name: '中共党员', value: '中共党员' },
                                                    { name: '中国预备党员', value: '中国预备党员' },
                                                    { name: '共青团员', value: '共青团员' },
                                                    { name: '群众', value: '群众' }
                                                ],
                                                formTdAlign: 'text-left',
                                                optionGenerateType: 0,
                                                clearable: true,
                                                filterable: false,
                                                allowCreate: false
                                            }" :vo="scope.row" :can-edit="canEdit"
/>
                                                </template>
                                            </el-table-column>
                                            <el-table-column prop="workUnitAndPosition" label="工作单位及职务" align="center">
                                                <template slot-scope="scope">
                                                    <form-item
ref="workUnitAndPosition"
                                                        :field="{ defaultValue: null, elementCanEdit: '{${canEdit}}', elementCssHeight: null, elementCssWidth: null, elementFormatter: null, elementReadonly: 0, elementType: 'input', emptyMessage: '请输入工作单位及职务', errorMessage: null, formTdAlign: 'text-left', formTdColspan: 0, isRequired: 0, onClickEvent: null, passenger: {}, propComment: '工作单位及职务', propName: 'workUnitAndPosition', propType: 'String', textFormatter: 'textfield', valueMaxLength: null, valueMinLength: null, model: 'scope.row.workUnitAndPosition', option: [], autocomplete: 'off', showWordLimit: false }"
                                                        :vo="scope.row" :can-edit="canEdit"
/>
                                                </template>
                                            </el-table-column>
                                            <!-- <el-table-column v-if="canEdit" label="操作" align="center" width="70px">
                                    <template slot-scope="scope">
                                        <el-link type="primary" @click="delClick(scope.row)">删除</el-link>
                                    </template>
                                </el-table-column> -->
                                        </el-table>
                                    </div>
                                </td>
                            </tr>
                            <tr>
                                <td ref="tdlbl_父亲姓名" class="el-table__cell tdlbl tdw13" colspan="1">

                                    <span v-field-lbl="'fatherName'" class="field">父亲姓名</span>
                                </td>
                                <td class="el-table__cell tdcont tdw20" colspan="1">
                                    <form-item
ref="fatherName"
                                        :field="{'defaultValue':null,'elementCanEdit':'{${canEdit}}','elementCssHeight':null,'elementCssWidth':null,'elementFormatter':null,'elementType':'input','emptyMessage':'请输入父亲姓名','errorMessage':null,'formTdAlign':'text-left','formTdColspan':0,'isRequired':0,'onClickEvent':null,'passenger':{},'propComment':'父亲姓名','propName':'fatherName','propType':'String','textFormatter':'textfield','valueMaxLength':null,'valueMinLength':null,'model':'vo.fatherName','option':[]}"
                                        :vo="vo" :can-edit="canEdit"
/>
                                </td>
                                <td ref="tdlbl_父亲身份证号" class="el-table__cell tdlbl tdw13" colspan="1">

                                    <span v-field-lbl="'fatherIdNumber'" class="field">父亲身份证号</span>
                                </td>
                                <td class="el-table__cell tdcont tdw20" colspan="1">
                                    <form-item
ref="fatherIdNumber"
                                        :field="{'defaultValue':null,'elementCanEdit':'{${canEdit}}','elementCssHeight':null,'elementCssWidth':null,'elementFormatter':null,'elementType':'input','emptyMessage':'请输入父亲身份证号','errorMessage':null,'formTdAlign':'text-left','formTdColspan':0,'isRequired':0,'onClickEvent':null,'passenger':{},'propComment':'父亲身份证号','propName':'fatherIdNumber','propType':'String','textFormatter':'textfield','valueMaxLength':null,'valueMinLength':null,'model':'vo.fatherIdNumber','option':[]}"
                                        :vo="vo" :can-edit="canEdit"
/>
                                </td>
                                <td ref="tdlbl_其它监护人姓名" class="el-table__cell tdlbl tdw13" colspan="1">

                                    <span v-field-lbl="'otherGuardianName'" class="field">其它监护人姓名</span>
                                </td>
                                <td class="el-table__cell tdcont tdw20" colspan="1">
                                    <form-item
ref="otherGuardianName"
                                        :field="{'defaultValue':null,'elementCanEdit':'{${canEdit}}','elementCssHeight':null,'elementCssWidth':null,'elementFormatter':null,'elementType':'input','emptyMessage':'请输入其它监护人姓名','errorMessage':null,'formTdAlign':'text-left','formTdColspan':0,'isRequired':0,'onClickEvent':null,'passenger':{},'propComment':'其它监护人姓名','propName':'otherGuardianName','propType':'String','textFormatter':'textfield','valueMaxLength':null,'valueMinLength':null,'model':'vo.otherGuardianName','option':[]}"
                                        :vo="vo" :can-edit="canEdit"
/>
                                </td>
                            </tr>
                            <tr>
                                <td ref="tdlbl_母亲姓名" class="el-table__cell tdlbl tdw13" colspan="1">

                                    <span v-field-lbl="'motherName'" class="field">母亲姓名</span>
                                </td>
                                <td class="el-table__cell tdcont tdw20" colspan="1">
                                    <form-item
ref="motherName"
                                        :field="{'defaultValue':null,'elementCanEdit':'{${canEdit}}','elementCssHeight':null,'elementCssWidth':null,'elementFormatter':null,'elementType':'input','emptyMessage':'请输入母亲姓名','errorMessage':null,'formTdAlign':'text-left','formTdColspan':0,'isRequired':0,'onClickEvent':null,'passenger':{},'propComment':'母亲姓名','propName':'motherName','propType':'String','textFormatter':'textfield','valueMaxLength':null,'valueMinLength':null,'model':'vo.motherName','option':[]}"
                                        :vo="vo" :can-edit="canEdit"
/>
                                </td>
                                <td ref="tdlbl_母亲身份证号" class="el-table__cell tdlbl tdw13" colspan="1">

                                    <span v-field-lbl="'motherIdNumber'" class="field">母亲身份证号</span>
                                </td>
                                <td class="el-table__cell tdcont tdw20" colspan="1">
                                    <form-item
ref="motherIdNumber"
                                        :field="{'defaultValue':null,'elementCanEdit':'{${canEdit}}','elementCssHeight':null,'elementCssWidth':null,'elementFormatter':null,'elementType':'input','emptyMessage':'请输入母亲身份证号','errorMessage':null,'formTdAlign':'text-left','formTdColspan':0,'isRequired':0,'onClickEvent':null,'passenger':{},'propComment':'母亲身份证号','propName':'motherIdNumber','propType':'String','textFormatter':'textfield','valueMaxLength':null,'valueMinLength':null,'model':'vo.motherIdNumber','option':[]}"
                                        :vo="vo" :can-edit="canEdit"
/>
                                </td>
                                <td ref="tdlbl_其他监护人身份证号" class="el-table__cell tdlbl tdw13" colspan="1">

                                    <span v-field-lbl="'otherGuardianIdNumber'" class="field">其他监护人身份证号</span>
                                </td>
                                <td class="el-table__cell tdcont tdw20" colspan="1">
                                    <form-item
ref="otherGuardianIdNumber"
                                        :field="{'defaultValue':null,'elementCanEdit':'{${canEdit}}','elementCssHeight':null,'elementCssWidth':null,'elementFormatter':null,'elementType':'input','emptyMessage':'请输入其他监护人身份证号','errorMessage':null,'formTdAlign':'text-left','formTdColspan':0,'isRequired':0,'onClickEvent':null,'passenger':{},'propComment':'其他监护人身份证号','propName':'otherGuardianIdNumber','propType':'String','textFormatter':'textfield','valueMaxLength':null,'valueMinLength':null,'model':'vo.otherGuardianIdNumber','option':[]}"
                                        :vo="vo" :can-edit="canEdit"
/>
                                </td>
                            </tr>
                            <tr>
                                <td ref="tdlbl_是否三区三州学生" class="el-table__cell tdlbl tdw13" colspan="1">

                                    <span v-field-lbl="'isThreeRegionsStudent'" class="field">是否三区三州学生</span>
                                </td>
                                <td class="el-table__cell tdcont tdw20" colspan="1">
                                    <form-item
ref="isThreeRegionsStudent"
                                        :field="{'defaultValue':'否','elementCanEdit':'{${canEdit}}','elementCssHeight':null,'elementCssWidth':null,'elementFormatter':'0：否\n1：是','elementReadonly':1,'elementType':'radio','emptyMessage':'','errorMessage':null,'isRequired':0,'onClickEvent':null,'passenger':{},'propComment':'是否三区三州学生','propName':'isThreeRegionsStudent','propType':'String','textFormatter':null,'valueMaxLength':null,'valueMinLength':null,'tbFieldName':'isthreeregionsstudent','iconName':'dxk','model':'vo.isThreeRegionsStudent','option':[{'value':'0','name':'否'},{'name':'是','value':'1'}],'formTdAlign':'text-left','optionGenerateType':0,'clearable':false,'filterable':false,'allowCreate':false}"
                                        :vo="vo" :can-edit="canEdit"
/>
                                </td>
                                <td ref="tdlbl_是否连片特困地区" class="el-table__cell tdlbl tdw13" colspan="1">

                                    <span v-field-lbl="'isPoorArea'" class="field">是否连片特困地区</span>
                                </td>
                                <td class="el-table__cell tdcont tdw20" colspan="1">
                                    <form-item
ref="isPoorArea"
                                        :field="{'defaultValue':'否','elementCanEdit':'{${canEdit}}','elementCssHeight':null,'elementCssWidth':null,'elementFormatter':'0：否\n1：是','elementReadonly':1,'elementType':'radio','emptyMessage':'','errorMessage':null,'isRequired':0,'onClickEvent':null,'passenger':{},'propComment':'是否连片特困地区','propName':'isPoorArea','propType':'String','textFormatter':null,'valueMaxLength':null,'valueMinLength':null,'tbFieldName':'ispoorarea','iconName':'dxk','model':'vo.isPoorArea','option':[{'value':'0','name':'否'},{'name':'是','value':'1'}],'formTdAlign':'text-left','optionGenerateType':0,'clearable':false,'filterable':false,'allowCreate':false}"
                                        :vo="vo" :can-edit="canEdit"
/>
                                </td>
                                <td ref="tdlbl_审核审批状态" class="el-table__cell tdlbl tdw13" colspan="1">

                                    <span v-field-lbl="'reviewApprovalStatus'" class="field">审核审批状态</span>
                                </td>
                                <td class="el-table__cell tdcont tdw20" colspan="1">
                                    <form-item
ref="reviewApprovalStatus"
                                        :field="{'defaultValue':'审核通过','elementCanEdit':'{${canEdit}}','elementCssHeight':null,'elementCssWidth':null,'elementFormatter':'审核通过：审核通过\n审核不通过：审核不通过','elementReadonly':1,'elementType':'select','emptyMessage':'','errorMessage':null,'isRequired':0,'onClickEvent':null,'passenger':{},'propComment':'审核审批状态','propName':'reviewApprovalStatus','propType':'String','textFormatter':null,'valueMaxLength':50,'valueMinLength':null,'tbFieldName':'reviewapprovalstatus','iconName':'xialakuang','model':'vo.reviewApprovalStatus','option':[{'value':'审核通过','name':'审核通过'},{'name':'审核不通过','value':'审核不通过'}],'formTdAlign':'text-left','optionGenerateType':0,'clearable':false,'filterable':false,'allowCreate':false}"
                                        :vo="vo" :can-edit="canEdit"
/>
                                </td>
                            </tr>
                            <tr>
                                <td ref="tdlbl_学生标识" class="el-table__cell tdlbl tdw13" colspan="1">

                                    <span v-field-lbl="'studentIdentification'" class="field">学生标识</span>
                                </td>
                                <td class="el-table__cell tdcont tdw83" colspan="5">
                                    <form-item
ref="studentIdentification"
                                        :field="{'defaultValue':null,'elementCanEdit':'{${canEdit}}','elementCssHeight':null,'elementCssWidth':null,'elementFormatter':'0：非毕业离校\n1：校特困生\n2：烈属\n3：侨属','elementReadonly':1,'elementType':'select','emptyMessage':'请选择学生标识','errorMessage':null,'formTdAlign':'text-left','formTdColspan':0,'isRequired':0,'onClickEvent':null,'passenger':{},'propComment':'学生标识','propName':'studentIdentification','propType':'String','textFormatter':null,'valueMaxLength':null,'valueMinLength':null,'model':'vo.studentIdentification','option':[{'value':'0','name':'非毕业离校'},{'value':'1','name':'校特困生'},{'value':'2','name':'烈属'},{'value':'3','name':'侨属'}],'optionGenerateType':0,'clearable':false,'filterable':false,'allowCreate':false}"
                                        :vo="vo" :can-edit="canEdit"
/>
                                </td>
                            </tr>
                            <tr>
                                <td ref="tdlbl_备注" class="el-table__cell tdlbl tdw13" colspan="1">

                                    <span v-field-lbl="'remarks1'" class="field">备注</span>
                                </td>
                                <td class="el-table__cell tdcont tdw83" colspan="5">
                                    <form-item
ref="remarks1"
                                        :field="{'defaultValue':null,'elementCanEdit':'{${canEdit}}','elementCssHeight':70,'elementCssWidth':null,'elementFormatter':null,'elementType':'textarea','emptyMessage':'请输入备注','errorMessage':null,'formTdAlign':'text-left','formTdColspan':0,'isRequired':0,'onClickEvent':null,'passenger':{},'propComment':'备注','propName':'remarks1','propType':'String','textFormatter':'textarea','valueMaxLength':null,'valueMinLength':null,'model':'vo.remarks1','option':[]}"
                                        :vo="vo" :can-edit="canEdit"
/>
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </div>
        </el-form>
        <div class="el_dialog_footer">
            <el-button v-if="canEdit==0" type="primary" @click="canEdit=1">修改</el-button>
            <el-button v-if="canEdit==1" type="info" @click="canEdit=0">取消</el-button>
            <el-button v-if="canEdit==1" type="primary" @click="handleSubmit">提交</el-button>
        </div>
    </div>
</template>

<script>
export default {
    props: {
        vo: {
            type: Object,
            default: function() {
                return {}
            }
        },
        //canEdit: { type: Number, default: 1 },
        moduleInfo: {
            type: Object,
            default: function() {
                return {}
            }
        }
    },
    data: function() {
        return {
            canEdit: 0,
            loginUser: this.$store.getters.loginUser,
            viewFile: false,
            fileList: [],
            imageSrc: '',

            type: '',
            oldMajor: null,
            oldMajorSub: null,
            majorVersion: '',
            admissionYear: '',
            nativePlace: '',
            ethnicity: '',
            placeOptions: [{
                'label': '北京',
                'value': '1'
            }, {
                'label': '天津',
                'value': '2'
            }, {
                'label': '河北',
                'value': '3'
            }, {
                'label': '山西',
                'value': '4'
            }, {
                'label': '内蒙古',
                'value': '5'
            }, {
                'label': '辽宁',
                'value': '6'
            }, {
                'label': '吉林',
                'value': '7'
            }, {
                'label': '黑龙江',
                'value': '8'
            }, {
                'label': '上海',
                'value': '9'
            }, {
                'label': '江苏',
                'value': '10'
            }, {
                'label': '浙江',
                'value': '11'
            }, {
                'label': '安徽',
                'value': '12'
            }, {
                'label': '福建',
                'value': '13'
            }, {
                'label': '江西',
                'value': '14'
            }, {
                'label': '山东',
                'value': '15'
            }, {
                'label': '河南',
                'value': '16'
            }, {
                'label': '湖北',
                'value': '17'
            }, {
                'label': '湖南',
                'value': '18'
            }, {
                'label': '广东',
                'value': '19'
            }, {
                'label': '广西',
                'value': '20'
            }, {
                'label': '海南',
                'value': '21'
            }, {
                'label': '重庆',
                'value': '22'
            }, {
                'label': '四川',
                'value': '23'
            }, {
                'label': '贵州',
                'value': '24'
            }, {
                'label': '云南',
                'value': '25'
            }, {
                'label': '西藏',
                'value': '26'
            }, {
                'label': '陕西',
                'value': '27'
            }, {
                'label': '甘肃',
                'value': '28'
            }, {
                'label': '青海',
                'value': '29'
            }, {
                'label': '宁夏',
                'value': '30'
            }, {
                'label': '新疆',
                'value': '31'
            }, {
                'label': '台湾',
                'value': '32'
            }, {
                'label': '香港',
                'value': '33'
            }, {
                'label': '澳门',
                'value': '34'
            }],
            familyMembers: []

        }
    },
    computed: {},
    watch: {},
    created: function() {
        if (this.$parent.$vnode.context.activeTabIndex) {
            this.activeTabName = this.$parent.$vnode.context.activeTabIndex
        }

        this.$set(this.$vnode.context, 'wfAttach', false)

        this.oldMajor = this.vo.majorCategory
        this.oldMajorSub = this.vo.majorSubcategory
        if (this.vo.idPhoto) {
            this.viewFile = true
        }

        this.$http({
            method: 'post',
            url: 'xsgl/studentFamilyMembers/listdata',
            params: {
                urlsearch: `studentId:${this.vo?.studentId}`
            }
        }).then((res) => {
            if (res.code === 'success') {
                this.familyMembers = res.body.pageInfo.list
            }
        })
    },
    beforeDestroy: function() {},
    mounted: function() {
        this.imageSrc =
                `${location.origin}${process.env.VUE_APP_BASE_API}/xsgl/studentBasicInfo/download?dataField=idPhoto&nameField=photoUrl&id=${this.vo.id}&httpPort=${location.port}`
        this.oldMajor = this.vo.majorCategory
        this.oldMajorSub = this.vo.majorSubcategory
    },
    methods: {
        handleUploadChange(filed, fileList) {
            if (filed.name.indexOf('.jpg') === -1 && filed.name.indexOf('.png') === -1 && filed.name.indexOf(
                '.JPG') === -1 && filed.name.indexOf('.PNG') === -1) {
                this.$alert('上传文件格式错误', '提示', {
                    confirmButtonText: '确定',
                    type: 'warning'
                })
                return
            }
            filed.id = this.vo.id
            this.$set(this.vo, 'idPhoto', filed.name)
            this.vo.idPhoto = filed.name
            this.fileList = fileList
        },
        upLoadImage() {
            this.$app.upload('/xsgl/studentBasicInfo/upload', this.fileList[0].raw, {
                'id': this.fileList[0].id,
                'nameField': 'photoUrl',
                'dataField': 'idPhoto'
            }).then(res => {
                if (res.code == 'success') {
                    this.$message({
                        type: 'success',
                        message: '保存成功！'
                    })
                } else {
                    this.$message.error('文件保存失败！')
                }
            })
        },
        handleSubmit() {
            this.$http({
                method: 'put',
                url: '/xsgl/studentBasicInfo/update',
                data: this.vo
            }).then(res => {
                if (res.code == 'success') {
                    this.$message({
                        type: 'success',
                        message: '保存成功！'
                    })
                    this.canEdit = 0
                    if (this.fileList.length > 0) {
                        this.upLoadImage()
                    }
                    //window.close();
                }
            })
        },
        onBasicFormBeforeSubmit: function($scope, vo, defer) {
            console.log('basicInfo form submit validation success')
            if (!vo.studentFileStatus) {
                vo.studentFileStatus = '0'
            }
            if (!vo.majorCategoryId) {
                this.$message({
                    type: 'warning',
                    message: '请选择院系'
                })
                defer.reject(reason)
                return
            } else if (!vo.majorSubcategoryId) {
                this.$message({
                    type: 'warning',
                    message: '请选择专业'
                })
                defer.reject(reason)
                return
            } else if (!vo.classId) {
                this.$message({
                    type: 'warning',
                    message: '请选择班级'
                })
                defer.reject(reason)
                return
            } else {
                defer.resolve(true)
            }
        },
        onBasicFormSubmited: function($scope, vo) {
            console.log('basicInfo form submit validation success')
            if (this.fileList.length > 0) {
                this.upLoadImage()
            }
            this.canEdit = 0
            //window.close();
        },
        versionChange: function(val) {
            this.$set(this.vo, 'majorVersion', this.majorVersion)
        },
        yearChange: function(val) {
            this.$set(this.vo, 'admissionYear', this.admissionYear)
        },
        selectType(type) {
            this.type = type
            console.log(this.oldMajor, this.oldMajorSub)
        },
        onDialogListDataBeforeLoad($scope, qparams) {
            console.log('onDialogListDataBeforeLoad', $scope)
            qparams.urlsearch = ''
            if (this.type == 'className') {
                if (this.vo.majorSubcategory) {
                    qparams.urlsearch = 'schoolMajorsId:' + this.vo.majorSubcategoryId
                } else {
                    this.$message({
                        type: 'warning',
                        message: '请先选择专业！'
                    })
                    return
                }
            } else if (this.type == 'sub') {
                if (this.vo.majorCategoryId) {
                    qparams.urlsearch = 'parentId:' + this.vo.majorCategoryId
                } else {
                    this.$message({
                        type: 'warning',
                        message: '请先选择院系！'
                    })
                    return
                }
            }
        },
        onSelectListpageRowCompleted(val, attr) {
            if (attr.name == 'majorCategory') {
                this.$set(this.vo, 'majorCategory', val[0].majorName)
                this.$set(this.vo, 'majorCategoryId', val[0].id)
                if (this.oldMajor) {
                    if (this.oldMajor != val[0].majorName) {
                        this.$set(this.vo, 'majorSubcategory', null)
                        this.$set(this.vo, 'majorSubcategoryId', null)
                        this.$set(this.vo, 'majorId', null)
                        this.$set(this.vo, 'majorName', null)
                        this.$set(this.vo, 'classCode', null)
                        this.$set(this.vo, 'classId', null)
                        this.$set(this.vo, 'className', null)
                    }
                } else {
                    this.oldMajor = val[0].majorName
                }
            } else if (attr.name == 'majorSubcategory') {
                this.$set(this.vo, 'majorSubcategory', val[0].majorName)
                this.$set(this.vo, 'majorSubcategoryId', val[0].id)
                this.$set(this.vo, 'majorId', val[0].id)
                this.$set(this.vo, 'majorName', val[0].majorName)
                if (this.oldMajorSub) {
                    if (this.oldMajorSub != val[0].majorName) {
                        this.$set(this.vo, 'classCode', null)
                        this.$set(this.vo, 'classId', null)
                        this.$set(this.vo, 'className', null)
                    }
                } else {
                    this.oldMajorSub = val[0].majorName
                }
            } else if (attr.name == 'className') {
                this.$set(this.vo, 'classCode', val[0].classCode)
                this.$set(this.vo, 'classId', val[0].classId)
                this.$set(this.vo, 'className', val[0].className)
            }
        },
        onInnerTableListDataBeforeLoad($scope, qparams) {
            qparams.urlsearch = `studentId:${this.vo?.studentId}`
        },
        addfamilyMembers() {
            this.$http({
                method: 'POST',
                url: '/xsgl/studentFamilyMembers/addNew'
            }).then((res) => {
                console.log(res, 'res')
                if (res.code === 'success') {
                    this.vo.passenger.familyMembers.push(res.body.vo)
                }
            })
        },
        // 删除当前行
        delClick(row) {
            // 找到要删除的项的索引
            this.vo.passenger.familyMembers = this.vo.passenger.familyMembers.filter((item) => item.id !== row.id)
        }

    }
}
</script>

<style scoped>
    .el_dialog_footer {
        padding-top: 20px;
        display: flex;
        justify-content: center;
    }

    .familyMembers_title {
        height: 48px;
        display: flex;
        align-items: center;
        justify-content: space-between;
        background: #f2f5fb;
        border-top: 1px solid #e3e8ee;
        border-bottom: 1px solid #999;
        padding: 4px 6px !important;
        padding: 4px 6px 4px 0 !important;
        font-size: 14px;
        color: #333;
    }
</style>
